import { render, staticRenderFns } from "./MentorTile.vue?vue&type=template&id=6ceadace&scoped=true&"
import script from "./MentorTile.vue?vue&type=script&lang=js&"
export * from "./MentorTile.vue?vue&type=script&lang=js&"
import style0 from "./MentorTile.vue?vue&type=style&index=0&id=6ceadace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceadace",
  null
  
)

export default component.exports